var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTransferIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0C9BAB"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2 1.5C19.2.67 18.664 0 18 0c-.664 0-1.2.67-1.2 1.5V24h2.4V9h4.2c.33 0 .6-.338.6-.75v-6c0-.413-.27-.75-.6-.75h-4.2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.38 1.86 5.22 5.593V24h.037H3.6c-.664 0-1.2-.67-1.2-1.5v-9H1.2c-.503 0-.953-.39-1.125-.98-.173-.59-.038-1.251.345-1.66l8.4-9c.45-.482 1.114-.482 1.564 0h-.004ZM8.4 9.75V12H6.6c-.33 0-.6.338-.6.75v1.5c0 .412.27.75.6.75h1.8v2.25c0 .413.27.75.6.75h1.2c.33 0 .6-.337.6-.75V15h1.8c.33 0 .6-.338.6-.75v-1.5c0-.412-.27-.75-.6-.75h-1.8V9.75c0-.413-.27-.75-.6-.75H9c-.33 0-.6.337-.6.75Z",
  opacity: 0.4
}))));
export default SvgTransferIcon;